// This file is auto-generated.
// It's responsible for connecting with Simple Tools.

import { Tools } from 'Simple/Tools'
import React from 'react'
import App from './flow'


export default function AppTools({ children, viewPath, ...props }) {
  return (
    <Tools>
      
      <App {...props} viewPath="/App">
        {children}
      </App>
    </Tools>
  )
}
